"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyForProject() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  return <section id="bereit-für-ihr-bauvorhaben" className="dark bg-background text-foreground relative overflow-hidden py-24 md:py-32 lg:py-40 flex items-center justify-center border-y border-border/10">
      {}
      <div className="absolute inset-0 opacity-[0.03] bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1594803/img/topographical_pattern_dark_bg.png')] bg-cover bg-center pointer-events-none" aria-hidden="true" />
      
      {}
      <div className="absolute inset-0 bg-radial from-transparent to-background/80 pointer-events-none" aria-hidden="true" />

      <div ref={ref} className={`relative z-10 container mx-auto px-4 md:px-6 flex flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="text-4xl md:text-5xl lg:text-7xl font-bold tracking-tight text-balance mb-10 max-w-4xl">
          Bereit für Ihr Bauvorhaben?
        </h2>

        <div className="w-full max-w-5xl mb-12 rounded-md overflow-hidden border border-border/20 bg-muted/5 shadow-2xl shadow-black/40">
          <iframe src="https://maps.google.com/maps?q=Gymnasialstraße%202,%2055543%20Bad%20Kreuznach&t=&z=15&ie=UTF8&iwloc=&output=embed" width="100%" height="400" style={{
          border: 0
        }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Standort" className="grayscale invert opacity-70 hover:opacity-100 transition-opacity duration-700" />
        </div>
        
        <Link to="/ContactPage" className="group">
          <Button size="lg" className="h-16 px-10 text-lg md:text-xl font-bold bg-primary text-primary-foreground shadow-2xl shadow-primary/20 hover:shadow-primary/40 hover:bg-primary/90 transition-all duration-300 group-hover:scale-105 group-active:scale-95 rounded-md">
            Jetzt kostenlos anfragen
          </Button>
        </Link>
      </div>
    </section>;
}